import React, { useState, useEffect, useContext } from "react";
import { WhiteButton, SecondaryButton } from "../../../main_portal/components/common_components/Buttons";
import Modal from "../../../main_portal/components/common_components/Modal";
import EnvelopeIcon from "../../../../../../assets/images/researcher_app/sign_up/envelope_icon.png";
import ConfettiIcon from "../../../../../../assets/images/researcher_app/sign_up/confetti.png";
import XIcon from "../../../../../../assets/images/researcher_app/create/x_button.svg";
import WarningIcon from "../../../../../../assets/images/researcher_app/overview/shield_warning_icon.svg";


function PurpleCheckEmailModal(props) {
    const style = {
        maxWidth: "350px",
        gap: "32px"
    }

    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen} closeable={false} backgroundColor="dark">
            <PurpleCard style={style}>
                <button className="modal-close-button" onClick={props.toggleModal}>
                    <img src={XIcon} height={24} width={24} />
                </button>
                <div className="purple-modal-content">
                    <img src={EnvelopeIcon} />
                    <div className="purple-modal-text-container">
                        <div className="purple-modal-title">
                            Check your email!
                        </div>
                        <div className="purple-modal-text-and-subtext">
                            <div className="purple-modal-text">
                                We've emailed you a link. Click the link to confirm your account.
                            </div>
                            <div className="purple-modal-text">
                                <span style={{ fontWeight: 600 }} >Can't find the email? </span> Check your spam or junk folder.                        </div>
                        </div>
                    </div>
                </div>
                <div className="purple-modal-button-container">
                    <WhiteButton text="Close" onClick={props.toggleModal} />
                </div>
            </PurpleCard>
        </Modal>
    )

}

function PurpleCompanyExistsModal(props) {
    const style = {
        maxWidth: "350px",
        gap: "32px"
    }
    const domain = props.email.split("@")[1]

    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen} closeable={false} backgroundColor="dark">
            <PurpleCard style={style}>
                <button className="modal-close-button" onClick={props.toggleModal}>
                    <img src={XIcon} height={24} width={24} />
                </button>
                <div className="purple-modal-content">
                    <img src={ConfettiIcon} />
                    <div className="purple-modal-text-container">
                        <div className="purple-modal-title">
                            Your colleagues are using despark
                        </div>
                        <div className="purple-modal-text-and-subtext">
                            <div className="purple-modal-text">
                                Would you like to request to join their account?
                            </div>
                            <div className="company-and-domain-container">
                                <div className="company-and-domain-grid">
                                    <div className="company-and-domain-grid-item-label">Company:</div>
                                    <div className="company-and-domain-grid-item-value">{props.companyName}</div>
                                    <div className="company-and-domain-grid-item-label">Domain:</div>
                                    <div className="company-and-domain-grid-item-value">{domain}</div>
                                </div>
                                <div className="purple-modal-text-gray-note">
                                    Not your company? Email us at info@despark.io
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="purple-modal-button-container">
                    <WhiteButton text="Request to join" onClick={props.onSubmit} style={{ flexGrow: 1 }} />
                </div>
            </PurpleCard>
        </Modal>
    )

}


function PurpleCard(props) {
    return (
        <div className="purple-modal-card" style={props.newStyle}>
            {props.children}
        </div>
    )
}

export { PurpleCheckEmailModal, PurpleCompanyExistsModal }